/* eslint-disable no-unused-vars */
import axios from "../../axios";

export default {
  namespaced: true,
  state: {
    course: {},
    courses: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
  },
  mutations: {
    SET_LIST(state, data) {
      state.courses = data;
    },
    SET_DETAIL(state, course) {
      state.course = course;
    },
    SET_CURRENT_PAGE(state, page) {
      state.pagination.current_page = page;
    },
    SET_PER_PAGE(state, size) {
      state.pagination.per_page = size;
    },
    REMOVE_RECORD(state, itemId) {
      if (Array.isArray(itemId)) {
        itemId.forEach((item) => {
          const index = state.courses.findIndex((u) => u.id === item);
          state.courses.splice(index, 1);
        });
      } else {
        const index = state.courses.findIndex((u) => u.id === itemId);
        state.courses.splice(index, 1);
      }
    },
    CREATE_SUCCESS(state, data) {
      state.courses.unshift(data);
    },
    UPDATE_SUCCESS(state, data) {
      const pos = state.courses
        .map(function (e) {
          return e.id;
        })
        .indexOf(data.id);
      state.courses.splice(pos, 1, data);
    },
  },
  actions: {
    async getCustomizedCourses({ commit }, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`customized-courses?${new URLSearchParams(query)}`)
          .then((response) => {
            commit("SET_LIST", response.data?.data?.items || []);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Detail
     * @param commit
     * @param id
     * @returns {Promise<{}|*>}
     */
    async detail({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/customized-courses/${id}`)
          .then((response) => {
            commit("SET_DETAIL", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Create self study course
     * @param commit
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    async create({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("customized-courses", payload)
          .then((response) => {
            commit("CREATE_SUCCESS", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Clone self study course
     * @param commit
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    async clone({ commit }, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/customized-courses/${id}/clone`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Update self study course
     * @param commit
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    async update({ commit }, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/customized-courses/${id}`, payload)
          .then((response) => {
            commit("UPDATE_SUCCESS", response.data.data);
            commit("SET_DETAIL", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * Delete self study course
     * @param commit
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    delete({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customized-courses/${id}`)
          .then((response) => {
            commit("REMOVE_RECORD", id);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     * set current page
     * @param commit
     * @param page
     */
    setCurrentPage({ commit }, page) {
      commit("SET_CURRENT_PAGE", page);
    },

    /**
     * set per page
     * @param commit
     * @param size
     */
    setPerPage({ commit }, size) {
      commit("SET_PER_PAGE", size);
    },
  },
  getters: {},
};
